import { combineReducers } from "redux";
import cart from "./cart";
import deliveryType from "./delivery-type";
import outfit from "./outfit";
import changeModel from "./change-model";
import giftCards from "./gift-cards";

export default combineReducers({
  cart,
  deliveryType,
  outfit,
  changeModel,
  giftCards,
});
